import $ from 'jquery';
import AlertService from '../common/alert/AlertService';

export function noDataloggerInfo(errorMessage) {
  AlertService.showWarning(errorMessage, { TTL: 10 });
}

export function noDataloggerInfoWithLink(errorMessage, linkText) {
  const errorMessageWithLinkText = `${errorMessage} <a href="#" id="no-datalogger-info-link">${linkText}</a>`;
  AlertService.showWarning(errorMessageWithLinkText, { TTL: 10 });

  $('.alerts').on('click', '#no-datalogger-info-link', (event) => {
    event.preventDefault();
    event.stopPropagation();

    $('#administration-control').trigger('click');
  });
}
